import { onMounted, ref, watch } from 'vue';
import { useDisplay } from 'vuetify';

export function useLandingIsMobile() {
    const display = useDisplay();

    // Keep deterministic for hydration; compute actual value after mount.
    const isMobile = ref(false);

    onMounted(() => {
        isMobile.value = display.mobile.value;

        watch(display.mobile, (value) => {
            isMobile.value = value;
        });
    });

    return { isMobile };
}
